module.exports = "/images/PT.webp?1b845c233eaf79a9bc172d30925f94e0";